/* d/auto-bind */ function _(require, module, exports) {
    var copy = require(342) /* es5-ext/object/copy */, normalizeOptions = require(352) /* es5-ext/object/normalize-options */, ensureCallable = require(357) /* es5-ext/object/valid-callable */, map = require(351) /* es5-ext/object/map */, callable = require(357) /* es5-ext/object/valid-callable */, validValue = require(359) /* es5-ext/object/valid-value */, bind = Function.prototype.bind, defineProperty = Object.defineProperty, hasOwnProperty = Object.prototype.hasOwnProperty, define;
    define = function (name, desc, options) {
        var value = validValue(desc) && callable(desc.value), dgs;
        dgs = copy(desc);
        delete dgs.writable;
        delete dgs.value;
        dgs.get = function () {
            if (!options.overwriteDefinition && hasOwnProperty.call(this, name))
                return value;
            desc.value = bind.call(value, options.resolveContext ? options.resolveContext(this) : this);
            defineProperty(this, name, desc);
            return this[name];
        };
        return dgs;
    };
    module.exports = function (props /*, options*/) {
        var options = normalizeOptions(arguments[1]);
        if (options.resolveContext != null)
            ensureCallable(options.resolveContext);
        return map(props, function (desc, name) { return define(name, desc, options); });
    };
}
